import SubCardGroupConnected from './SubCardGroupConnected'
export default SubCardGroupConnected
